import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  clientsList: [],
  categoriesList: [],
  productsList: [],
};

export const helperSlice = createSlice({
  name: "helper",
  initialState,
  reducers: {
    setClientsList: (state, action) => {
      state.clientsList = action.payload;
    },
    setCategoriesList: (state, action) => {
      state.categoriesList = action.payload;
    },
    setProductsList: (state, action) => {
      state.productsList = action.payload;
    },
  },
});

export const { setClientsList, setProductsList, setCategoriesList } =
  helperSlice.actions;
